import { createSlice } from '@reduxjs/toolkit';

/**
 * When the pantry was last brought in line with reality.
 *
 * This slice used to drive a "Vos courses étaient prévues aujourd'hui" modal
 * off a declared weekly shop day. The card that set that day
 * (`PantrySyncDeclarationCard`) was rendered by #423 and then dropped by the
 * #468 weekly redesign, but `pantrySync` stayed in the redux-persist
 * whitelist — so a day picked during that three-week window was frozen in
 * storage with no UI left to change it, and `promptState:
 * 'dismissed-permanently'` never had a reducer to set it. The prompt fired
 * from the shop day through Sunday, every week, on every page load, with no
 * off switch. That is #641, and the trigger is gone with it.
 *
 * `lastUpdatedAt` survives because it is the one honest fact here: four call
 * sites (receipt scan, recognition results, both pantry review surfaces)
 * already record a real user action, and it is the signal a *passive*
 * staleness nudge would need. It is written only — nothing reads it, and
 * nothing should render off it without a design pass. Persisted state that
 * silently drives UI is exactly what caused #641.
 */
export interface PantrySyncState {
  lastUpdatedAt: string | null;
}

const initialState: PantrySyncState = {
  lastUpdatedAt: null,
};

const pantrySyncSlice = createSlice({
  name: 'pantrySync',
  initialState,
  reducers: {
    markPantryUpdated(state) {
      state.lastUpdatedAt = new Date().toISOString();
    },
  },
});

export const { markPantryUpdated } = pantrySyncSlice.actions;
export default pantrySyncSlice.reducer;
